import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-mdl-filter-opportunities',
  standalone: true,
  imports: [FormsModule,CommonModule],
  templateUrl: './mdl-filter-opportunities.html',
  styleUrl: './mdl-filter-opportunities.css'
})
export class MdlFilterOpportunities {
  constructor(
    public mdl: MatDialogRef<MdlFilterOpportunities>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data?.filters) {
      this.filters = { ...this.filters, ...data.filters };
    }
    this.ejecutivos = data?.ejecutivos || [];    
  }

  filters = {
    allStages: true,
    allTypes: true,
    allProbabilities: true,
    amountRange: 'all',
    closingDateRange: 'all',
    ejecutivoId: 'all',
    stages: {
      prospeccion: false,
      calificacion: false,
      propuesta: false,
      negociacion: false,
      cerradaGanada: false,
      cerradaPerdida: false
    },
    types: {
      nuevoNegocio: false,
      negocioExistente: false,
      renovacion: false
    },
    probabilities: {
      baja: false,
      media: false,
      alta: false
    }
  };

  ejecutivos: any[] = [];


  stageTypes: Array<keyof typeof this.filters.stages> = [
    'prospeccion',
    'calificacion',
    'propuesta',
    'negociacion',
    'cerradaGanada',
    'cerradaPerdida'
  ];

  businessTypes: Array<keyof typeof this.filters.types> = [
    'nuevoNegocio',
    'negocioExistente',
    'renovacion'
  ];

  probabilityTypes: Array<keyof typeof this.filters.probabilities> = [
    'baja',
    'media',
    'alta'
  ];

  toggleAllStages() {
    if (this.filters.allStages) {
      for (const key of this.stageTypes) {
        this.filters.stages[key] = true;
      }
    } else {
      for (const key of this.stageTypes) {
        this.filters.stages[key] = false;
      }
    }
  }

  onStageChange() {
    const allStagesSelected = this.stageTypes.every(key => this.filters.stages[key]);
    const anyStageSelected = this.stageTypes.some(key => this.filters.stages[key]);
    
    this.filters.allStages = allStagesSelected;
    
    if (!anyStageSelected) {
      this.filters.allStages = true;
      this.toggleAllStages();
    }
  }

  toggleAllTypes() {
    if (this.filters.allTypes) {
      for (const key of this.businessTypes) {
        this.filters.types[key] = true;
      }
    } else {
      for (const key of this.businessTypes) {
        this.filters.types[key] = false;
      }
    }
  }

  onTypeChange() {
    const allTypesSelected = this.businessTypes.every(key => this.filters.types[key]);
    const anyTypeSelected = this.businessTypes.some(key => this.filters.types[key]);
    
    this.filters.allTypes = allTypesSelected;
    
    if (!anyTypeSelected) {
      this.filters.allTypes = true;
      this.toggleAllTypes();
    }
  }

  toggleAllProbabilities() {
    if (this.filters.allProbabilities) {
      for (const key of this.probabilityTypes) {
        this.filters.probabilities[key] = true;
      }
    } else {
      for (const key of this.probabilityTypes) {
        this.filters.probabilities[key] = false;
      }
    }
  }

  onProbabilityChange() {
    const allProbabilitiesSelected = this.probabilityTypes.every(key => this.filters.probabilities[key]);
    const anyProbabilitySelected = this.probabilityTypes.some(key => this.filters.probabilities[key]);
    
    this.filters.allProbabilities = allProbabilitiesSelected;
    
    if (!anyProbabilitySelected) {
      this.filters.allProbabilities = true;
      this.toggleAllProbabilities();
    }
  }

  closeMdl() {
    this.mdl.close();
  }

  applyFilters() {
    this.mdl.close(this.filters);
  }
}